import { Card, Checkbox, Col, Form, Row, Typography } from 'antd'
import React from 'react'

export default function SoftwareFilters({form}) {
  
  const options = [
    {
      label: 'Punto Cassa',
      value: 'cash_desk',
    },
    {
      label: 'E-Commerce',
      value: 'e_commerce',
    },
    {
      label: 'WebApp',
      value: 'webapp',
    },
    {
      label: 'Portale di Prenotzione',
      value: 'booking',
    },
    {
      label: 'AppMobile (Android ed iOS)',
      value: 'app_mobile',
    },
  ];

  return (
    <>
      <div className='di-filters-group-wrapper mt-20 mb-30'>
       <div className='p-10'>
          <Form.Item name="softwares_list" label="Seleziona solo gli utenti che sono censiti nei seguenti software">
            <Checkbox.Group>
              <Row>
                {options.map((e) => (
                  <Col key={e.value}>
                    <Checkbox value={e.value}>{e.label}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
       </div>
      </div>
    </>
  )
}
